import React from 'react'

import MinKavlifavorittOverview from '../../../react4xp/components/MinKavlifavorittOverview'

function MinKavlifavorittOverviewPart({title, intro, image, cta, filters, endpoint, likedMinKavlifavoritt, startValues, images, strings, hasMinKavliFavoritt, services, isLogged}) {
	return (
		<MinKavlifavorittOverview 
			title={title}
			intro={intro}
			image={image}
			cta={cta}
			filters={filters}
			endpoint={endpoint}
			likedMinKavlifavoritt={likedMinKavlifavoritt}
			hasMinKavliFavoritt={hasMinKavliFavoritt}
			startValues={startValues}
			images={images}
			strings={strings}
			services={services}
			isLogged={isLogged}
		/>
	)
}

export default (props) => <MinKavlifavorittOverviewPart {...props} />
